import { FiUsers } from "react-icons/fi";
import { PiChartLineUpBold } from "react-icons/pi";
import { FaGear } from "react-icons/fa6";
import {
  MdDashboard,
  MdPeople,
  MdAttachMoney,
  MdEventNote,
  MdSettings,
  MdChurch,
  MdBarChart,
  MdNotifications,
  MdGroups,
} from "react-icons/md";


export const superAdminNavigations = [
  {
    name: "Super Dashboard",
    path: "/super/dashboard",
    icon: <MdDashboard />,
  },
  { name: "Churches", path: "/super/churches", icon: <MdChurch /> },
  { name: "Analytics", path: "/super/analytics", icon: <MdBarChart /> },
  {
    name: "Notifications",
    path: "/super/notifications",
    icon: <MdNotifications />,
  },
  { name: "Settings", path: "/super/settings", icon: <MdSettings /> },
];

export const navigations = [
  { name: "Dashboard", path: "/dashboard", icon: <MdDashboard /> },
  { name: "Members", path: "/members", icon: <MdPeople /> },
  { name: "Visitors", path: "/visitors", icon: <MdPeople /> },
  {
    icon: <FiUsers />,
    name: "User Management",
    path: "/user-management",
  },
  { name: "Groups Management", path: "/group-management", icon: <MdGroups /> },
  { name: "Attendance Report", path: "/church-attendance/report", icon: <MdGroups /> },
  {
    name: "Finance",
    hasDropdown: true,
    icon: <MdAttachMoney />,
    dropdownItems: [
      { name: "Overview", path: "/finance/overview" },
      { name: "Income", path: "/finance/income" },
      { name: "Expenses", path: "/finance/expenses" },
      { name: "Income statement", path: "/finance/income-statement" },
      
    ],
  },
  // { name: "Reports", path: "/reports", icon: <MdBarChart /> },
  { name: "Settings", path: "/settings", icon: <MdSettings /> },
];

export const financeManagerNavigations = [
  {
    name: "Finance Dashboard",
    path: "/dashboard",
    icon: <MdDashboard />,
  },
  {
    icon: <FiUsers />,
    name: "Member Management",
    path: "/members",
  },
  {
    icon: <PiChartLineUpBold />,
    name: "Finance",
    path: "/finance",
    hasDropdown: true,
    dropdownItems: [
      { name: "Overview", path: "/finance/overview" },
      { name: "Incomes", path: "/finance/income" },
      { name: "Expenses", path: "/finance/expenses" },
      { name: "Income statement", path: "/finance/income-statement" },
    ],
  },
  {
    icon: <FaGear />,
    name: "Settings",
    path: "/settings",
  },
];

export const groupLeaderNavigations = [
  { name: "Dashboard", path: "/groups/dashboard", icon: <MdDashboard /> },
  { name: "Group Members", path: "/groups/members", icon: <MdPeople /> },

  { name: "Attendance", path: "/groups/attendance", icon: <MdGroups /> },
];


export const usherNavigations = [
  { name: "Dashboard", path: "/usher/dashboard", icon: <MdDashboard /> },
  { name: "Members", path: "/members", icon: <MdPeople /> },
  { name: "Visitors", path: "/visitors", icon: <MdPeople /> },
  { name: "Attendance", path: "/church-attendance", icon: <MdGroups /> },
];
